import './accommodations-slider.scss'

export const component = {
    name: 'accommodations-slider',

    data: {
        accommodationIndex: 0
    },

    computed: {
        currentTab() {
            return this.tabs[this.tabsIndex]
        }
    },

    methods: {
        accommodationNext() {
            if (this.accommodationIndex < (this.accommodations.length - 4)) {
                this.accommodationIndex++
            }
        },

        accommodationPrev() {
            if (this.accommodationIndex > 0) {
                --this.accommodationIndex
            }
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/accommodations-slider/accommodations-slider.js